import React from "react"
import { useNavigate } from "react-router-dom"

import "../../page/Shop/Shop.css"
import iconCheck from "../../assets/iconCheck.svg"

function OrderComplete() {

	const navigate = useNavigate()

	return (
		<>
			<div className="cardContent orderCmt">
				<form name="orderComplete">
					<div className="orderStatus">
						<span>
							<img src={iconCheck} alt="주문 완료 아이콘" />
						</span>
						<h3>주문완료</h3>
					</div>
					<div className="cmtText">주문 및 결제가 완료 되었습니다.</div>
					<div className="shopBtnWrap">
						<button
							type="button"
							onClick={() => {
								navigate("/my-page")
							}}>
							마이페이지 바로가기
						</button>
						<button
							type="submit"
							onClick={() => {
								navigate("/")
							}}>
							홈으로 이동
						</button>
					</div>
				</form>
			</div>
		</>
	)
}

export default OrderComplete
